import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=52e0e5d6"
import script from "./SystemMessage.vue?vue&type=script&lang=js"
export * from "./SystemMessage.vue?vue&type=script&lang=js"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&id=52e0e5d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports